import { serializeToUrl } from '@/src/lib/filters/filterSerializer';
import type { FilterState } from '@/src/lib/filters/filterTypes';
import { buildSrpPath } from '@/src/lib/seo/srpPath';

const APARTMENTS_SLUG = 'apartments-for-rent';

/**
 * The slug a search lands on: apartments-for-rent for an apartments-only search, or null for the
 * bare area URL. The query still carries `propertyTypes=apartment`, because the slug itself does
 * not filter on type until hotpads-api ships HP-9411 step 1.
 */
export function searchSlugForFilters(filters: FilterState): string | null {
  return filters.propertyTypes.length === 1 && filters.propertyTypes[0] === 'apartment' ? APARTMENTS_SLUG : null;
}

/**
 * Builds the SRP URL for a given resource + filter state.
 *
 * Used by ListingSearch in `navigate` mode (homepage hero), where filter
 * mutations sit in local draft state until the user clicks Search. The
 * homepage's original ad-hoc 25-line param builder is replaced with the
 * canonical `serializeToUrl` so URLs match the SRP's own serialization.
 */
export function buildSearchUrl(resourceId: string, filters: FilterState): string {
  const basePath = buildSrpPath(resourceId, searchSlugForFilters(filters));
  const params = new URLSearchParams(serializeToUrl(filters));
  const qs = params.toString();
  return qs ? `${basePath}?${qs}` : basePath;
}
